import { useState } from 'react';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'Über mich' },
    { id: 'services', label: 'Leistungen' },
    { id: 'contact', label: 'Kontakt' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <div className="flex items-center cursor-pointer ml-8 lg:ml-16" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/54e964387333a21262272d84478a5c26.png"
              alt="Love yourself beauty by Meltem"
              className="h-20 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled
                    ? 'text-gray-700 hover:text-rose-400'
                    : 'text-white hover:text-rose-300'
                }`}
              >
                {item.label}
              </button>
            ))}
            <a
              href="https://buchung.treatwell.de/ort/445747/menue/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-rose-400 to-rose-300 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Termin buchen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-gray-700 hover:text-rose-400 py-2 text-sm font-medium transition-colors whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
            <a
              href="https://buchung.treatwell.de/ort/445747/menue/"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-gradient-to-r from-rose-400 to-rose-300 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:shadow-lg transition-all whitespace-nowrap text-center cursor-pointer"
            >
              Termin buchen
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
